import React, { useState } from "react";
import "../../css/pages/services.css";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import HeroImage from "../../assets/images/FAQs1.jpg";
import Accordion from "../designSystem/Accordion";

const faqData = [
  {
    question: "Do I really need a financial adviser?",
    answer:
      "Many people manage their finances independently, but a financial adviser can help you bring everything together into a clear, structured plan. We provide guidance, clarity, and ongoing support—particularly around complex areas such as pensions, tax efficiency, and long-term planning—so you can make confident decisions. \n\nIn particular, business owners and high earners often have more moving parts to manage, including company profits, personal income, pensions, tax planning, investments, and succession or exit considerations. An independent financial adviser helps bring these areas together into one joined-up strategy, so your business success is translated into long-term personal wealth and financial security.",
  },
  {
    question: "What does an independent financial adviser do?",
    answer:
      "An independent financial adviser provides advice across the whole of the market rather than being restricted to a limited range of products or providers. This allows us to recommend solutions based on what is most suitable for your circumstances, whether you are planning for retirement, investing surplus capital, or building a more tax-efficient long-term plan.",
  },
  {
    question: "How can financial advice help business owners?",
    answer:
      "Financial advice can help business owners make better decisions around extracting profits, pension contributions, protecting the business, investing surplus cash, and planning for future exit or succession. The aim is to ensure that personal wealth grows alongside the business, rather than being left behind it.",
  },
  {
    question: "When should I start pension planning?",
    answer:
      "The earlier you start, the more options you tend to have. For many business owners and individuals, pension planning becomes especially important in the 5 to 15 years before retirement, when decisions around contributions, consolidation, tax efficiency, and retirement income start to have a significant long-term impact.",
  },
  {
    question: "Should I consolidate my pensions?",
    answer:
      "Pension consolidation can make your arrangements easier to manage and may help improve clarity, investment oversight, and retirement planning. However, it is not right in every case. Some pensions contain valuable guarantees or benefits, so any recommendation should only be made after careful analysis.",
  },
  {
    question: "How do I know whether I am on track for retirement?",
    answer:
      "This starts with understanding what retirement looks like for you. We use cashflow planning to help you see whether your current pensions, savings, and investments are likely to support your desired lifestyle, and what changes may be needed to strengthen your position.",
  },
  {
    question: "What is the difference between saving and investing?",
    answer:
      "Saving is usually more suitable for short-term needs, liquidity, and emergency reserves, while investing is generally used for longer-term growth. For high earners and business owners, the right balance between savings and investments can be key to maintaining flexibility while still building long-term wealth in a tax-efficient way.",
  },
  {
    question: "How do you decide where my money should be invested?",
    answer:
      "We look at your objectives, timescales, attitude to risk, and wider financial picture before recommending an investment strategy. This often means ensuring your investments work alongside your pensions, tax position, business plans, and family goals.",
  },
  {
    question: "How much risk should I take with my investments?",
    answer:
      "There is no single answer, because the right level of investment risk depends on both your mindset and your financial capacity to absorb losses. We help you understand what level of risk is appropriate, so your investment strategy feels considered, proportionate, and aligned with your long-term objectives.",
  },
  {
    question:
      "Can you help with both personal and business financial planning?",
    answer:
      "Yes. Many of our clients want joined-up advice that reflects both sides of their financial life. This may include pensions, investments, savings, protection, business exit planning, and broader wealth planning, so decisions made in the business support your personal future as well.",
  },
  {
    question: "How are you paid for your advice?",
    answer:
      "We believe in being clear and transparent about fees from the outset. Depending on the work involved, this may include an initial planning or advice fee and, where appropriate, an ongoing service fee. We explain all costs clearly before any commitment is made.",
  },
  {
    question: "What happens after I become a client?",
    answer:
      "Good financial planning is not a one-off event. As a client, you receive ongoing support and regular reviews so your plans can adapt to changes in your business, family life, legislation, and wider financial goals. Our role is to help you stay clear, confident, and in control over time.",
  },
];

const FAQsPage = () => {
  return (
    <div className="home-page about-page">
      <Hero
        title="FAQs"
        // subtitle="Equity release"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="page-section">
        <div className="page-section-inner">
          {faqData.map((item, idx) => (
            <div key={idx} className="faq-item">
              <Accordion title={item.question}>{item.answer}</Accordion>
            </div>
          ))}
        </div>
      </section>
      <section className="investment-note-section">
        <div className="home-container investment-note body">
          {/* <strong>Please Note:</strong> The value of protection products and the
          income they produce can fall as well as rise. You may get back less
          than you invested. Transferring out of a final salary pension is
          unlikely to be in the best interests of most people. */}
        </div>
      </section>
    </div>
  );
};

export default FAQsPage;
